import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
const componentName = 'Divider';
export const dividerClasses = {
    root: `ui-Divider-root-${randomStr()}`,
    textAlignLeft: 'ui-Divider-textAlignLeft',
    textAlignRight: 'ui-Divider-textAlignRight',
    wrapper: 'ui-Divider-wrapper',
    flexItem: 'ui-Divider-flexItem',
    withChildren: 'ui-Divider-WithChildren',
    withChildrenVertical: 'ui-Divider-withChildrenVertical',
    horizontal: 'ui-Divider-horizontal',
    vertical: 'ui-Divider-vertical',
    fullHeight: 'ui-Divider-fullHeight',
};
export function getStyle(theme, opts) {
    const dynamicToken = getDynamicThemeToken(theme);
    const { unit = 'px', orientationMargin } = opts;
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    const alignWidth = tk(token.textAlign);
    const remainAlignWidth = 100 - alignWidth;
    const borderStyle = opts?.dashed ? 'dashed' : 'solid';
    const color = tk(token.color);
    const style = {
        [`&.${dividerClasses.root}`]: {
            fontFamily: tk(token.fontFamily),
            borderColor: color,
            borderStyle,
            [`&.${dividerClasses.horizontal}`]: {
                [`&.${dividerClasses.withChildren}::before, &.${dividerClasses.withChildren}::after`]: { borderTopColor: color, borderTopStyle: borderStyle },
            },
            [`&.${dividerClasses.withChildrenVertical}::before, &.${dividerClasses.withChildrenVertical}::after`]: {
                borderLeftColor: color,
                borderLeftStyle: borderStyle,
            },
            [`&.${dividerClasses.vertical}:not(.${dividerClasses.flexItem}, .${dividerClasses.withChildrenVertical})`]: {
                display: 'inline-block',
                minHeight: '1em',
                margin: '0 8px',
                verticalAlign: '-3px',
                [`&.${dividerClasses.fullHeight}`]: {
                    height: '100%',
                },
            },
            [`&.${dividerClasses.vertical}.${dividerClasses.fullHeight}:not(.${dividerClasses.flexItem})`]: {
                height: '100%',
                verticalAlign: 'middle',
            },
        },
        [`&.${dividerClasses.textAlignLeft}::before, &.${dividerClasses.textAlignRight}::after`]: {
            width: `${alignWidth}%`,
        },
        [`&.${dividerClasses.textAlignRight}::before, &.${dividerClasses.textAlignLeft}::after`]: {
            width: `${remainAlignWidth}%`,
        },
        [`&.${dividerClasses.textAlignLeft}.orientationMargin::before`]: {
            width: `${orientationMargin}${unit}`,
        },
        [`&.${dividerClasses.textAlignRight}.orientationMargin::after`]: {
            width: `${orientationMargin}${unit}`,
        },
        ...(orientationMargin === 0 && {
            [`&.${dividerClasses.textAlignRight}.orientationMargin .${dividerClasses.wrapper}`]: {
                paddingRight: 0,
            },
            [`&.${dividerClasses.textAlignLeft}.orientationMargin .${dividerClasses.wrapper}`]: {
                paddingLeft: 0,
            },
        }),
    };
    return style;
}
